"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonLoader = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
/**
 * @component Renders a skeleton loader component with customizable styling.
 *
 * - The props object containing the following properties:
 * @prop {React.CSSProperties} style: Additional CSS styles to apply to the skeleton loader.
 * @return {ReactElement} The rendered skeleton loader component.
 */
var SkeletonLoader = function (_a) {
    var style = _a.style;
    return (react_1.default.createElement(styled_1.StyledSkeletonLoader, { style: style }));
};
exports.SkeletonLoader = SkeletonLoader;
